import getPending from './get-pending';
import getApproved from './get-approved';
import getRefused from './get-refused';
import requestApprovation from './request-approvation';
import reject from './reject';
import accept from './accept';
import removeItem from './remove-item';
import updateItem from './update-item';
import getCount from './get-count';

export default {
	getPending,
	getApproved,
	getRefused,
	requestApprovation,
	reject,
	accept,
	removeItem,
	updateItem,
	getCount
};
